import gql from 'graphql-tag';

export const contractManagementDocumentsQuery = gql`
  query ContractManagementDocuments(
    $search: [String!]
    $offset: Int
    $limit: Int
    $tags: [String!]
    $folderId: String
    $users: [String!]
    $value: [Float!]
    $contractLength: [Int!]
    $contractEndDate: [DateTime]
    $documentType: DocumentType
    $documentTypes: [DocumentType!]
    $signDate: [DateTime]
    $sortBy: String
    $sortOrder: String
    $showInAllFolders: Boolean
  ) {
    contractManagement(
      search: $search
      offset: $offset
      limit: $limit
      tags: $tags
      folderId: $folderId
      users: $users
      valueFloat: $value
      contractLength: $contractLength
      contractEndDate: $contractEndDate
      documentType: $documentType
      documentTypes: $documentTypes
      signDate: $signDate
      sortBy: $sortBy
      sortOrder: $sortOrder
      showInAllFolders: $showInAllFolders
    ) {
      name
      id
      recipients {
        firstName
        lastName
        email
      }
      user {
        id
        firstName
        lastName
        email
      }
      companyName
      value
      contractStartDate
      contractEndDate
      signDate
      tags {
        title
        status
        id
      }
    }
  }
`;

export const contractManagementKeyValuesQuery = gql`
  query ContractManagementKeyValues(
    $search: [String!]
    $offset: Int
    $limit: Int
    $tags: [String!]
    $folderId: String
    $users: [String!]
    $value: [Float!]
    $contractLength: [Int!]
    $contractEndDate: [DateTime]
    $documentType: DocumentType
    $documentTypes: [DocumentType!]
    $sortBy: String
    $sortOrder: String
    $showInAllFolders: Boolean
  ) {
    contractManagementKeyValues(
      search: $search
      offset: $offset
      limit: $limit
      tags: $tags
      folderId: $folderId
      users: $users
      valueFloat: $value
      contractLength: $contractLength
      contractEndDate: $contractEndDate
      documentType: $documentType
      documentTypes: $documentTypes
      sortBy: $sortBy
      sortOrder: $sortOrder
      showInAllFolders: $showInAllFolders
    ) {
      average
      sum
      count
    }
  }
`;

export const filterRangesQuery = gql`
  query FilterRanges {
    contractManagementFilterRanges {
      minValue
      maxValue
      minContractLength
      maxContractLength
      minContractEndDate
      maxContractEndDate
    }
  }
`;

export const allTagsQuery = gql`
  query AllTags {
    entity {
      tags {
        id
        title
        status
      }
    }
  }
`;

export const fetchDownloadDocuments = gql`
  query DownloadDocuments($documentIds: [String!]!) {
    downloadDocuments(documentIds: $documentIds) {
      documentId
      documentName
      documentLink
    }
  }
`;

export const documentNotificationsQuery = gql`
  query DocumentNotifications {
    documentNotifications {
      notificationDate
      notificationType
      notificationNote
      created_at
      id
      user {
        id
      }
      document {
        id
        name
        contractEndDate
      }
    }
  }
`;
